import { cn } from '@/lib/utils'
import { Check } from 'lucide-react'

interface StepperProps {
  steps: string[]
  current: number
  onJump?: (i: number) => void
  className?: string
}

export function Stepper({ steps, current, onJump, className }: StepperProps) {
  return (
    <div className={cn('flex items-center gap-2 overflow-x-auto pb-1', className)}>
      {steps.map((label, i) => {
        const done = i < current
        const active = i === current
        return (
          <div key={i} className="flex items-center gap-2 shrink-0">
            <button
              type="button"
              onClick={() => onJump && done ? onJump(i) : undefined}
              className={cn(
                'flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium transition',
                done && 'bg-emerald-50 text-emerald-700 border border-emerald-200',
                active && 'bg-amber-500 text-white shadow-md shadow-amber-500/30',
                !done && !active && 'bg-slate-50 text-slate-500 border border-slate-200'
              )}
            >
              <span
                className={cn(
                  'inline-flex items-center justify-center w-5 h-5 rounded-full text-[10px] font-bold',
                  done && 'bg-emerald-500 text-white',
                  active && 'bg-white text-amber-600',
                  !done && !active && 'bg-slate-200 text-slate-500'
                )}
              >
                {done ? <Check className="w-3 h-3" /> : i + 1}
              </span>
              {label}
            </button>
            {i < steps.length - 1 && (
              <div
                className={cn(
                  'w-6 h-px',
                  i < current ? 'bg-emerald-300' : 'bg-slate-200'
                )}
              />
            )}
          </div>
        )
      })}
    </div>
  )
}
